module.exports = "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASoZABkAPpFCm0ono6IiKAgA8BIJZwDGfBdvrAAA/vEOR1qYdIm7DuMqhY/KvcRxkEJAuAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/chocolate_martini.webp
// module id = IQLB
// module chunks = 14